import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { HourToDayPartHourPipe, HourToDayPartPipe } from '@libs/utils';
@Component({
  selector: 'lib-schedule-calendar-time-column',
  templateUrl: './schedule-calendar-time-column.component.html',
  styleUrl: './schedule-calendar-time-column.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HourToDayPartPipe, HourToDayPartHourPipe],
})
export class ScheduleCalendarTimeColumnComponent {
  @Input() public calendarGridTemplateRows!: string;
  @Input() public hours!: number[];
  @Input() public minutesInTimeline!: number[];
}
